'use strict'

export default (mockAxios) => {
  mockAxios.onPost(`/login`).reply(200, {
    'success': true,
    'data': {
      'token': 'xxx',
      'company_code': '00000',
      'sid_corporate': 1,
      'login_user': {
        'is_admin': true
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/authRepositoryMock.js